<script setup lang="ts">
interface FilterOption {
  key: string
  label: string
  urlPath?: string
  count?: number
  active?: boolean
  children?: FilterOption[]
  [key: string]: unknown
}

interface Filter {
  key: string
  [key: string]: unknown
}

const meta = inject('meta', ref())
const route = useRoute()

const props = defineProps<{
  filter: Filter
  option: FilterOption
}>()

const getUrl = computed(() => {
  const filterKey = props.filter.key
  const queryParams = new Map(Object.entries({ filter: 1, ...route.query, [filterKey]: props.option.key }))
  let path = route.path.replace('/merken/', '/')

  if (meta.value?.page_type === 'plp-theme') {
    meta?.value.filters.forEach((item: any) => {
      queryParams.set(item.key, item.values.join('~'))
    })
  }
  if (['plp-brand', 'plp-filter'].includes(meta.value?.page_type) && !props.option.urlPath.includes('/')) {
    queryParams.delete(filterKey)
    path = props.option.urlPath + path
  }
  if (!['plp-brand', 'search', 'plp-filter'].includes(meta.value?.page_type)) {
    queryParams.delete(filterKey)
    path = props.option.urlPath
  }
  if (queryParams.size > 1 && !queryParams.has('p')) {
    return `${path}?${(new URLSearchParams(Object.fromEntries(queryParams))).toString()}`
  }

  return path
})

const isActiveCategoryInTree = (item: FilterOption): boolean => {
  if (item.active === true) {
    return true
  }
  if (item.children) {
    for (const child of item.children) {
      if (isActiveCategoryInTree(child)) {
        return true
      }
    }
  }
  return false
}
</script>

<template>
  <li>
    <AppLink
      :to="getUrl"
      class="filter-links__link"
      :class="{ 'filter-links__link--active': option.active }"
    >
      {{ option.label }} <span class="filter-links__count">{{ option.count }}</span>
    </AppLink>

    <ul
      v-if="isActiveCategoryInTree(option)"
      class="filter-links-tree"
    >
      <FilterLinksItem
        v-for="child in option.children"
        :key="child.key"
        :option="child"
        :filter="filter"
        class="filter-links-tree__item"
      />
    </ul>
  </li>
</template>
